import React from "react";
import { replaceQuotationMarksWithGuillemets } from "../../util/format/guillemets";
var PageSectionHeading = function PageSectionHeading(_ref) {
    var title = _ref.title, textColor = _ref.textColor, className = _ref.className;
    var color = textColor ? textColor : "makroOrange";
    return /*#__PURE__*/ React.createElement("div", {
        className: "block w-full text-xl text-" + color + " uppercase " + (className || "")
    }, replaceQuotationMarksWithGuillemets(title));
};
export default PageSectionHeading;
